import { InstagramCard } from 'components/InstagramCard/InstagramCard';
import blackInstagram from 'images/icons/blackInstagram.svg';
import './styles.scss';
import { useSelector } from 'react-redux';

const Instagram = () => {
    const { instagram_photo_1, instagram_photo_2, instagram_photo_3, instagram_photo_4, instagram_title } =
        useSelector(state => state?.homepage?.data?.data) || {};

    return (
        <section className="container">
            <div className="instagram-news">
                <div className="instagram-image-wrapper">
                    <div className="h1">{instagram_title}</div>
                    <img src={blackInstagram} alt="instagram" />
                </div>
                <div className="first-instagram-card">
                    <InstagramCard image={instagram_photo_1} />
                </div>
                <div className="second-instagram-card">
                    <InstagramCard image={instagram_photo_2} />
                </div>
                <div className="third-instagram-card">
                    <InstagramCard image={instagram_photo_3} />
                </div>
                <div className="fourth-instagram-card">
                    <InstagramCard image={instagram_photo_4} />
                </div>
            </div>
        </section>
    );
};

export default Instagram;
